import * as cpfCnpjValidator from "cpf-cnpj-validator";

const cpfRegex = /(\d{3})?(\d{1,3})?(\d{1,3})?(\d{1,2})?/gi;
const cnpjRegex = /^(\d{2})?(\d{1,3})?(\d{1,3})?(\d{1,4})?(\d{1,2})?$/gi;

export const stripCpf = (cpf, limited) =>
  cpfCnpjValidator.cpf.strip(limited ? cpf.substr(0, 11) : cpf);
export const stripCnpj = (cnpj, limited) =>
  cpfCnpjValidator.cnpj.strip(limited ? cnpj.substr(0, 14) : cnpj);

export const formatCpf = (cpf, limited) => {
  if (!cpf || typeof cpf !== "string") {
    return "";
  }
  const onlyNumbersCpf = cpf.replace(/\D/gi, "");
  return (limited
    ? onlyNumbersCpf.substr(0, 11)
    : onlyNumbersCpf
  ).replace(cpfRegex, (...[, $1, $2, $3, verificador]) =>
    [[$1, $2, $3].filter((a) => a).join("."), verificador]
      .filter((b) => b)
      .join("-")
  );
};

export const formatCnpj = (cnpj, limited) => {
  if (!cnpj || typeof cnpj !== "string") {
    return "";
  }
  const onlyNumbersCnpj = cnpj.replace(/\D/gi, "");
  return (limited
    ? onlyNumbersCnpj.substr(0, 14)
    : onlyNumbersCnpj
  ).replace(cnpjRegex, (...[, $1, $2, $3, $4, verificador]) =>
    [
      [[$1, $2, $3].filter((a) => a).join("."), $4].filter((b) => b).join("/"),
      verificador,
    ]
      .filter((c) => c)
      .join("-")
  );
};

export const validateCpf = (cpf) => cpfCnpjValidator.cpf.isValid(cpf);
export const validateCnpj = (cnpj) => cpfCnpjValidator.cnpj.isValid(cnpj);
